import Vue from 'vue';
import productPackagingTransformer from './../../transformers/productPackaging';
import store from './../../store';

const success = ({ data }) => productPackagingTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const productPackagings = store.state.productPackaging.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (productPackagings.length > 0) {
      return resolve(productPackagings[0]);
    }

    return Vue.$http.get(`/product_packagings/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productPackaging/show.js